import PurchaseOrder from '@models/purchase-order';
import PurchaseRequest from '@models/purchase-request';
import { orderBy } from 'lodash';

import ApiClient from '@/api-client';

export default {
    namespaced: true,
    state: {
        purchaseRequest: { items: [] },
        settings: false,
        purchaseOrders: [],
        files: [],
    },
    getters: {
        isStatic(state, getters, rootState, rootGetters) {
            return (
                state.purchaseRequest.status !== 'Draft'
                && state.purchaseOrders
                && state.purchaseOrders.length > 0)
                || state.purchaseRequest.status === 'Closed'
                || (state.purchaseRequest.status !== 'Draft' && !rootGetters['AuthenticationStore/roles'].includes('purchasing_admin'));
        },
        isDraft(state) {
            return state.purchaseRequest.status === 'Draft';
        },
        isRequested(state) {
            return state.purchaseRequest.status === 'Requested';
        },
        isOrdering(state) {
            return state.purchaseRequest.status === 'Requested'
                    || state.purchaseRequest.status === 'Closed'
                    || state.purchaseRequest.status === 'Ordered'
                    || state.purchaseRequest.status === 'Confirmed'
                    || state.purchaseRequest.status === 'Backordered';
        },
        hasItemReceipts(state) {
            return state.purchaseOrders.length ? !!state.purchaseOrders.filter((purchaseOrder) => !!purchaseOrder.items.filter((item) => item.item_receipts.length > 0).length).length : false;
        },
    },
    mutations: {
        setPurchaseRequest(state, purchaseRequest) {
            state.purchaseRequest = purchaseRequest;
        },
        updatePurchaseRequest(state, purchaseRequest) {
            Object.keys(purchaseRequest).forEach((field) => {
                state.purchaseRequest[field] = purchaseRequest[field];
            });
        },
        updateItem(state, item) {
            const requestItem = state.purchaseRequest.items.find((purchaseRequestItem) => purchaseRequestItem.id === item.id);

            if (item) {
                Object.keys(requestItem).forEach((field) => {
                    requestItem[field] = item[field];
                });
            }
        },
        setRequestItems(state, items) {
            state.purchaseRequest.items = items;
        },
        setPurchaseOrders(state, purchaseOrders) {
            state.purchaseOrders = purchaseOrders;
        },
        setPurchaseRequestFiles(state, files) {
            state.files = files;
        },
        setSettings(state, settings) {
            state.settings = settings;
        },
    },
    actions: {
        async getPurchaseRequestSettings({ commit }) {
            const response = await ApiClient.get('/api/purchase-requests/settings');
            commit('setSettings', response.data);
        },
        async getPurchaseRequest({ commit }, purchaseRequestId) {
            const purchaseRequest = await PurchaseRequest.with(
                'customer',
                'customerLocation',
                'department',
                'job',
                'requestedBy',
                'branch',
                'items.vendor',
                'items.item',
                'purchaseRequestCategory',
                'order',
            ).find(purchaseRequestId);
            commit('setPurchaseRequest', purchaseRequest);
        },
        async getPurchaseRequestOrders({ commit }, purchaseRequestId) {
            const purchaseOrders = await PurchaseOrder
                .where('purchase_request_id', purchaseRequestId)
                .with('items.vendor', 'items.glCode', 'vendor', 'items.itemReceipts', 'items.shipments', 'items.shipments.items', 'items.item')
                .get();

            commit('setPurchaseOrders', purchaseOrders);
        },
        async submitRequest({ commit, state }) {
            const response = await ApiClient.patch(`/api/purchase-requests/${state.purchaseRequest.id}/submit`);
            commit('updatePurchaseRequest', response.data);
        },
        async updateItem({ state, commit }, item) {
            const response = await ApiClient.patch(`/api/purchase-requests/${state.purchaseRequest.id}/purchase-items/${item.id}`, item);
            commit('updateItem', response.data);
        },
        sortRequestItems({ commit, state }, value) {
            let items;

            if (value.charAt(0) === '-') {
                items = orderBy(state.purchaseRequest.items, value.replace('-', ''), 'desc');
            } else {
                items = orderBy(state.purchaseRequest.items, value, 'asc');
            }
            commit('setRequestItems', items);
        },
        async getFiles({ commit, state }) {
            const response = await ApiClient.get(`/api/purchase-requests/${state.purchaseRequest.id}/files`);
            commit('setPurchaseRequestFiles', response.data.data);
        },
        reset({ commit }) {
            commit('setPurchaseRequest', { items: [] });
            commit('setPurchaseOrders', []);
            commit('setSettings', false);
            commit('setPurchaseRequestFiles', []);
        },
    },
};
